import { createContext, ReactNode, useState } from "react";

export type ViewModeType = "light" | "contrast";

export const ViewModeContext = createContext<{
  mode: ViewModeType;
  setMode: (mode: ViewModeType) => void;
  font: number;
  setFont: (font: number) => void;
} | null>(null);

const ViewModeProvider = ({ children }: { children: ReactNode }) => {
  const [mode, setMode] = useState<ViewModeType>("light");
  const [font, setFont] = useState<number>(14);
  return (
    <ViewModeContext.Provider value={{ mode, setMode, font, setFont }}>
      {children}
    </ViewModeContext.Provider>
  );
};

export default ViewModeProvider;
